import React from 'react';
import { useTranslation } from 'react-i18next';

const NeuronHoverCard = ({ neuron, user, position }) => {
    const { t } = useTranslation();
    if (!neuron || !position) return null;

    // Basic user info, assuming 'user' prop will be fetched and passed in
    const author = user || { displayName: t('neuronHoverCard.anonymous'), photoURL: null };
    const badges = user?.badges || [];

    return (
        <div style={{
            position: 'absolute',
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: 'translate(-50%, -110%)', // Position above the neuron
            width: '280px',
            padding: '15px',
            background: 'rgba(20, 20, 35, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(138, 43, 226, 0.5)',
            borderRadius: '12px',
            boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
            color: 'white',
            zIndex: 1000,
            transition: 'opacity 0.2s ease-in-out, transform 0.2s ease-in-out',
            pointerEvents: 'none', // Prevent the card from blocking mouse events on the canvas
        }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                <img 
                    src={author.photoURL || '/default-avatar.png'} 
                    alt={author.displayName} 
                    style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }} 
                />
                <h4 style={{ margin: 0, fontSize: '1rem' }}>{author.displayName}</h4>
            </div>
            
            <div style={{ marginBottom: '12px', borderTop: '1px solid #444', paddingTop: '12px' }}>
                <p style={{
                    margin: 0,
                    fontSize: '0.85rem',
                    color: '#ccc',
                    maxHeight: '60px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    "{neuron.content}"
                </p>
            </div>

            {badges.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {badges.map(badge => (
                        <span key={badge.id} title={badge.name} style={{ fontSize: '1.2rem' }}>
                            {badge.icon}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NeuronHoverCard;
